var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-between divider-bar"},[_c('div',[_c('span',{staticClass:"divider"}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])]),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }